import { observer } from 'mobx-react-lite'
import { Box, Label } from 'shared/ui'
import { Select } from 'shared/ui/Select/Select'
import { MemberNameCell } from 'pages/settings/pages/members/pages/membersView/ui/MemberNameCell'
import { ChooseAssignInboxType } from 'pages/settings/pages/members/ui/AssignMemberToInbox/ui/ChooseAssignInboxType/ChooseAssignInboxType'
import { type AssignMemberToInboxStore } from 'pages/settings/pages/members/ui/AssignMemberToInbox/store/assignMemberToInboxStore'
import { AssignMemberToNewInbox } from 'pages/settings/pages/members/ui/AssignMemberToInbox/ui/AssignMemberToNewInbox/AssignMemberToNewInbox'
import { AssignMemberToExistingInbox } from 'pages/settings/pages/members/ui/AssignMemberToInbox/ui/AssignMemberToExistingInbox/AssignMemberToExistingInbox'
import styles from './styles.module.scss'

type IAssignMemberToInboxProps = {
  store: AssignMemberToInboxStore
}

export const AssignMemberToInbox = observer(({ store }: IAssignMemberToInboxProps) => {
  const {
    roleItems,
    role,
    handleRoleChange,
    inboxType,
    handleAssignInboxTypeChange,
    inboxOptions,
    accessRequest,
    isSalesmsgAccessMode,
    isReviewMode,
  } = store

  const memberInfo = accessRequest?.user

  return (
    <div className={styles.wrap}>
      {memberInfo && isReviewMode && (
        <MemberNameCell
          avatarInfo={memberInfo.avatarInfo}
          fullName={memberInfo.fullName}
          email={memberInfo.email}
        />
      )}
      {isSalesmsgAccessMode && (
        <Box display='flex' flexDirection='column' gap='4px' marginTop='16px' paddingBottom='8px'>
          <Label
            label={{
              text: 'Role',
            }}
          />
          <Select
            variant='stroke'
            items={roleItems}
            value={role}
            onSelectValue={handleRoleChange}
            dropdownProps={{
              withSearch: false,
            }}
            textFieldPlaceholderProps={{
              size: 'medium',
            }}
          />
        </Box>
      )}
      <Box marginTop={isReviewMode ? '16px' : '0px'} minWidth='492px'>
        <ChooseAssignInboxType
          selectedType={inboxType}
          inboxOptions={inboxOptions}
          onSelectType={handleAssignInboxTypeChange}
        />
      </Box>
      {inboxType === 'exist' && <AssignMemberToExistingInbox store={store} />}
      {inboxType === 'new' && <AssignMemberToNewInbox store={store} />}
    </div>
  )
})
